
import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { AiProvider } from './contexts/AiProviderContext';
import { StudentDataProvider } from './contexts/StudentDataContext';
import { NavigationProvider } from './contexts/NavigationContext'; // Correct named import
import { GamificationProvider } from './contexts/GamificationContext'; // Import GamificationProvider
import AppRoutes from './routes/AppRoutes';
import GlobalErrorBoundary from './components/common/GlobalErrorBoundary';
import { ThemeProvider } from './contexts/ThemeContext'; // Ensure ThemeProvider is back if it was there
import { SiswaProvider } from './contexts/SiswaContext'; // Ensure SiswaProvider is back if it was there

// Import Global CSS
import './index.css';

const App = () => {
    return (
        <GlobalErrorBoundary>
            <ThemeProvider>
                <AuthProvider>
                    <AiProvider>
                        <SiswaProvider>
                            <StudentDataProvider>
                                <GamificationProvider>
                                    <NavigationProvider>
                                        <AppRoutes />
                                    </NavigationProvider>
                                </GamificationProvider>
                            </StudentDataProvider>
                        </SiswaProvider>
                    </AiProvider>
                </AuthProvider>
            </ThemeProvider>
        </GlobalErrorBoundary>
    );
};

export default App;
